import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldWrapper } from '@ngx-formly/core';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';

@Component({
  templateUrl: 'collapse-wrapper.component.html',
  styleUrls: ['collapse-wrapper.component.scss'],
  imports: [...MSS_FORMLY_IMPORTS, FormsModule, ReactiveFormsModule],
})
export class CollapseWrapperComponent extends FieldWrapper {
  get label(): string {
    const text = this.props.label ?? '';
    const index = Number(this.field?.key);
    if (!Number.isNaN(index)) {
      return `${text} ${index + 1}`.trim();
    }
    return text;
  }

  get valid(): boolean {
    return (this.formControl?.dirty || this.formControl?.touched) && !!this.formControl?.valid;
  }

  get invalid(): boolean {
    return (!this.form?.pristine || this.formControl?.dirty || this.formControl?.touched) && !this.formControl?.valid;
  }
}
